import { Component, input, output, effect } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Error } from '../../../../../public-user-component/auth/shared/error/error';
import { NgClass } from '@angular/common';

export function regexValidator(regex: RegExp, errorKey: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null =>
    regex.test(control.value || '') ? null : { [errorKey]: true };
}

@Component({
  selector: 'app-attribute-form',
  standalone: true,
  imports: [ReactiveFormsModule, Error, NgClass],
  templateUrl: './attribute-form.html',
})
export class AttributeForm {
  productType = input<'edit' | 'create'>('create');
  existingKeys = input<string[]>([]);
  editData = input<{ titleEn: string; titleAr: string | null; index: number } | null>(null);
  externalError = input<string | null>(null);

  onAdd = output<{ titleEn: string; titleAr: string }>();
  onEdit = output<{ titleEn: string; titleAr: string; index: number }>();
  onImportClick = output<void>();
  onCancelEdit = output<void>();

  attributeForm = new FormGroup({
    titleEn: new FormControl('', [
      Validators.maxLength(100),
      regexValidator(/^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/, 'englishOnly'),
    ]),
    titleAr: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      regexValidator(/^[\u0600-\u06FF0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/, 'arabicOnly'),
    ]),
  });

  constructor() {
    effect(() => {
      const data = this.editData();
      if (data) this.attributeForm.patchValue({ titleEn: data.titleEn, titleAr: data.titleAr ?? '' });
      else this.attributeForm.reset();
    });
  }

  get isEditMode() {
    return this.editData() !== null;
  }

  handleSubmit() {
    if (this.attributeForm.invalid) return;
    const val = this.attributeForm.value;
    const trimmedEn = val.titleEn?.trim() || '';
    const currentIndex = this.editData()?.index ?? -1;
    if (
      trimmedEn &&
      this.existingKeys()
        .filter((_, i) => i !== currentIndex)
        .some((k) => k.toLowerCase() === trimmedEn.toLowerCase())
    ) {
      this.attributeForm.get('titleEn')?.setErrors({ alreadyExists: true });
      return;
    }
    if (this.isEditMode)
      this.onEdit.emit({ titleEn: trimmedEn, titleAr: val.titleAr!.trim(), index: currentIndex });
    else this.onAdd.emit({ titleEn: trimmedEn, titleAr: val.titleAr!.trim() });
    if (!this.isEditMode) this.attributeForm.reset();
  }

  handleCancel() {
    this.attributeForm.reset();
    this.onCancelEdit.emit();
  }
}
